import request from './request'

export function fetchProducts (params = {}) {
  return request.get('/products', { params })
}

export function fetchCategories (params = {}) {
  return request.get('/products/categories', { params })
}

export function fetchProductFilterOptions () {
  return request.get('/products/filters/options')
}

export function createProduct (payload) {
  return request.post('/products', payload)
}

export function updateProduct (id, payload) {
  return request.put(`/products/${id}`, payload)
}

export function deleteProduct (id) {
  return request.delete(`/products/${id}`)
}

export function createCategory (payload) {
  return request.post('/products/categories', payload)
}

export function updateCategory (id, payload) {
  return request.put(`/products/categories/${id}`, payload)
}

export function deleteCategory (id) {
  return request.delete(`/products/categories/${id}`)
}
